import { useModal } from "@lobby/core/src/shared";
import { useSearch } from "@tanstack/react-router";
import { useEffect } from "react";

import { LogInModal } from "widget/log-in-modal";
import { PasswordForgotModal } from "widget/password-forgot-modal";
import { RegisterModal } from "widget/register-modal";

export function SignInPage() {
  const search = useSearch({ from: "/sign-in" });
  const { open: openLogInModal } = useModal("log-in");
  const { open: openRegisterModal } = useModal("register");

  useEffect(() => {
    if (search.modal === "register") {
      openRegisterModal();
    } else if (search.modal !== "password-forgot") {
      openLogInModal();
    }
  }, [openLogInModal, openRegisterModal, search.modal]);

  return (
    <>
      <LogInModal isClosable={false} />
      <RegisterModal isClosable={false} />
      <PasswordForgotModal isClosable={false} />
    </>
  );
}
